// src/Pages/Clubs/ClubChatPage.jsx
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ClubChat from '../../Components/ClubChat/ClubChat';

export default function ClubChatPage() {
  const { state } = useLocation();
  const { id } = useParams();
  const clubFromState = state?.club;
  const clubFromStore = useSelector((s) =>
    s.clubs.allClubs.find(c => String(c.id) === id)
  );
  const club = clubFromState || clubFromStore;

  if (!club) {
    return <p>Club not found.</p>;
  }

  return <ClubChat club={club} />;
}
